import React from 'react'
import PropTypes from 'prop-types'
import StatusReportStatusIcon from '../../../StatusReportStatusIcon'

function StatusDisplayBoardLayout ({ statusInfo, size, useIcon, hasBackground }) {
  return (
    <StatusReportStatusIcon
      statusId={statusInfo?.statusId}
      status={statusInfo}
      size={size}
      useIcon={useIcon}
      hasBackground={hasBackground}
    />
  )
}

StatusDisplayBoardLayout.propTypes = {
  statusInfo: PropTypes.object,
  size: PropTypes.number,
  useIcon: PropTypes.bool,
  hasBackground: PropTypes.bool
}

StatusDisplayBoardLayout.defaultProps = {
  size: 14,
  useIcon: false,
  hasBackground: true
}

export default StatusDisplayBoardLayout
